import { UI, HStack, Stack, VStack } from '@genial/components';
import React from 'react';

export interface SubscriptionItemDetailsHeaderProps {
  title: string;
  subtitle: string;
  handleClose: () => void;
}

export const SubscriptionItemDetailsHeader: React.FC<SubscriptionItemDetailsHeaderProps> = ({
  title,
  subtitle,
  handleClose,
}) => {
  return (
    <HStack justifyContent="space-between">
      <VStack>
        <UI.Heading testId="subscription-title" size="h3">
          {title}
        </UI.Heading>
        <UI.Text color="neutral.dark">{subtitle}</UI.Text>
      </VStack>
      <Stack justifyContent="center">
        <UI.IconButton
          testId={'icon-close'}
          icon="CloseModal"
          iconSize="xs"
          borderWidth={{ base: 0, lg: '1px' }}
          variant="rounded"
          backgroundColor="transparent"
          iconColor="brand.primary.principal"
          borderColor="brand.primary.principal"
          onPress={handleClose}
          p={0}
        />
      </Stack>
    </HStack>
  );
};
